import { AscSimpleUserDetailsPropsI } from "./AscSimpleUserDetails.type";
import styles from "./AscSimpleUserDetails.module.scss";
import classNames from "classnames";
import AscAvatar from "../AscAvatar/AscAvatar";
// import AscTag from "../AscTag/AscTag";

function AscSimpleUserDetails({
  avatarUrl,
  flag,
  name,
  age,
}: AscSimpleUserDetailsPropsI) {
  // const getRankTag = (tag: number) => {
  //   switch (tag) {
  //     case 1:
  //       return <AscTag type={"gold"} label={"Gold"} size={"small"} />;
  //     case 2:
  //       return <AscTag type={"silver"} label={"Silver"} size={"small"} />;
  //     case 3:
  //       return <AscTag type={"bronze"} label={"Bronze"} size={"small"} />;
  //     default:
  //       return null;
  //   }
  // };

  return (
    <div className={classNames(styles.element)}>
      <AscAvatar
        className={styles.avatar}
        src={avatarUrl}
        alt={"avatar"}
        flag={flag}
      />

      <div className={styles.textWrapper}>
        <div className={styles.nameWrapper}>
          <div className={styles.name}>{name}</div>
          {/* {tag && getRankTag(tag)} */}
        </div>
        <div className={styles.details}>
          <div className={styles.age}>Age {age}</div>
        </div>
      </div>
    </div>
  );
}

export default AscSimpleUserDetails;
